import React from "react";
import McpLandingView from "./components/McpLandingView";

const McpPage: React.FC = () => {
  return <McpLandingView />;
};

export default McpPage;
